import { Injectable } from '@angular/core';
import { HttpClient } from "@angular/common/http";
import {SyncService} from "./sync.service";
import {Observable} from "rxjs";
import {KeyViewModel, NewKeyViewModel} from "../system/admin-panel/Keys/Model/KeyViewModel";
import {map} from "rxjs/operators";
import {RetranslationViewModel} from "../system/admin-panel/retranslators/Models/RetranslationViewModel";

@Injectable({
  providedIn: 'root'
})
export class RetranslationService {

  constructor(private client: HttpClient, private syncService: SyncService) {
  }

  public GetRetranslations(): Observable<RetranslationViewModel[]> {
    return this.client.get<RetranslationViewModel[]>('/ctrl/Retranslations').pipe(
      map(values => {
        const result: RetranslationViewModel[] = [];
        if (values && Array.isArray(values)) {
          for (let item of values) {
            result.push(RetranslationViewModel.fromJS(item));
          }
        }
        return result;
      })
    );
  }

  public GetRetranslation(id: number): Observable<RetranslationViewModel> {
    return this.client.get<any>('/ctrl/Retranslations/' + id).pipe(
      map(value => RetranslationViewModel.fromJS(value))
    );
  }

  public DeleteRetranslation(id: number): Observable<void> {
    return this.client.delete('/ctrl/Retranslations/' + id).pipe(
      map(() => {
        this.syncService.NotifyEntityChanged("Retranslation", id);
      })
    );
  }

  public EditRetranslation(model: RetranslationViewModel): Observable<void> | undefined {
    if (model.Id !== 0) {
      return this.client.put('/ctrl/Retranslations', model).pipe(
        map(() => {
          this.syncService.NotifyEntityChanged("Retranslation", model.Id);
        })
      );
    }
    return undefined;
  }

  public CreateRetranslation(model: RetranslationViewModel): Observable<void> {
    return this.client.post('/ctrl/Retranslations', model).pipe(
      map(() => {
        this.syncService.NotifyEntityChanged("Retranslation", model.Id);
      })
    );
  }

}
